import { Link } from "react-router-dom";
import type { MangaItem } from "@/mocks/comics";
import { getCategoryBySlug } from "@/mocks/categories";

interface ComicCardProps {
  comic: MangaItem;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const primaryCategory = getCategoryBySlug(comic.categorySlugs[0]);

  return (
    <article className="card-comic group">
      <Link to={`/article/${comic.slug}`} className="block cursor-pointer" aria-label={`阅读《${comic.title}》`}>
        <div className="relative aspect-[5/7] w-full overflow-hidden bg-background-200">
          <img
            src={comic.cover}
            alt={`${comic.title} 漫画封面`}
            title={`${comic.title} 漫画在线免费阅读`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span
            className={`absolute left-2 top-2 rounded-full px-2 py-0.5 text-[11px] font-medium text-background-50 ${
              comic.status === "已完结" ? "bg-accent-500" : "bg-primary-500"
            }`}
          >
            {comic.status}
          </span>
          <div className="absolute inset-0 flex items-end bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <span className="w-full py-3 text-center text-sm font-medium text-white">
              立即阅读<i className="ri-arrow-right-line ml-1" aria-hidden="true" />
            </span>
          </div>
        </div>
        <div className="p-3">
          <h3 className="truncate text-sm font-semibold text-foreground-950 md:text-base">
            {comic.title}
          </h3>
          <div className="mt-1.5 flex items-center justify-between gap-2 text-xs text-foreground-600">
            <span className="truncate">{comic.latestChapter}</span>
            <span className="flex shrink-0 items-center gap-1 whitespace-nowrap">
              <i className="ri-star-fill text-xs text-accent-500" aria-hidden="true" />
              {comic.rating.toFixed(1)}
            </span>
          </div>
          {primaryCategory && (
            <span className="mt-2 inline-flex items-center rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
              {primaryCategory.name}
            </span>
          )}
        </div>
      </Link>
    </article>
  );
}